import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde en üste çık
    window.scrollTo(0, 0);

    // Google Tag Manager'a (GTM) sanal sayfa değişimi bilgisini gönder (SPA uyumluluğu)
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.hash + location.search,
        page_title: document.title || 'Diba Halı Yıkama',
      });
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
